import type { VADState } from '../types/vad-state'

export const resolveAudioPlaybackVADState = (
  isAudioPlaying: boolean,
): VADState | null => (
  isAudioPlaying
    ? { status: 'paused', reason: 'audio_playing' }
    : null
)
